import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faStop, faForward, faBackward, faFastBackward, faFastForward } from '@fortawesome/free-solid-svg-icons';
import { saveAs } from 'file-saver';
import Loading from '../assets/loading.gif';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import classie from './js/classie.js';
import $ from 'jquery';
  
import './css/Style.css';
import './css/normalize.css';
import './css/demo.css';
import './css/component.css';

require('default-passive-events');

class Index extends Component {
  componentDidMount() {
    const { area } = this.props.match.params;

    var api_baseUrl = 'https://apivime.inmet.gov.br'; 
    var rotate_delay = 500;
    var imagens = [];
    var imagem_atual;
    var validades_imagem = [];
    var areas = {
      'COSMO2P8' : [
        { 'SE' : ['ES', 'MG', 'RJ', 'SP'] },
        { 'S'  : ['PR', 'RS', 'SC'] },
        { 'NE' : ['AL', 'BA', 'CE', 'MA', 'PB', 'PE', 'PI', 'RN', 'SE'] }
      ],
      'COSMO7'   : ['AS', 'BRA', 'CO', 'NE', 'N', 'SE', 'S'],
      'ECMWF'    : ['AS'],
      'GFS'      : ['AS', 'BRA', 'CO', 'NE', 'N', 'SE', 'S']
    }
    
    var init_modelo = 'COSMO7';
    var init_area = area ? area.toUpperCase() : areas[init_modelo][0];
    var init_parametro = 'prec24h';
    var init_data = null;
    var init_rodada = null;
    var isMenuOpen = false;

    function abrirMenu(bool){
      if(bool){
        classie.add( document.getElementById('menu'), 'gn-selected' );
        classie.add( document.getElementById('wrapper'), 'gn-open-all' );
        isMenuOpen = true;
      }else{
        classie.remove( document.getElementById('menu'), 'gn-selected' );
        classie.remove( document.getElementById('wrapper'), 'gn-open-all' );
        isMenuOpen = false;
      }
    } 

    function geraOptions(element, data, inicial = null, atributo_inicial = null) {
      // Primeira opção do select default
      var opt = document.createElement('option');
      // opt.innerHTML = 'Selecione';
      // element.append(opt);
      
      // Todas as opções do array
      for (var i = 0; i < data.length; i++) {
        opt = document.createElement('option');
        opt.value = data[i].sigla;
        opt.innerHTML = data[i].nome;
        
        if(inicial)
        if(atributo_inicial && data[i].sigla === atributo_inicial)
        opt.setAttribute('selected', 'selected');
        
        element.append(opt);
      }
    }
      
    function removeOption(element) {
      var elements = element.find('option');
      for (var i = 0; i < elements.length; i++)
      elements[i].remove();
    }

    function montarValidades(){
      $('.validades').find('span').remove()
      for(var i = 0; i < validades_imagem.length; i++){
        if(i === 0){
          $('.validades').append(`<span class="validade active" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">+${validades_imagem[i].nome.split('+')[1].padStart(3, '0')}</span>`)
        } else {
          $('.validades').append(`<span class="validade" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">+${validades_imagem[i].nome.split('+')[1].padStart(3, '0')}</span>`)
        }
      }
    }

    function montarAreas(modelo){
      $('.areas').find('span').remove()
      $('.areas').find('br').remove()

      if(modelo === 'COSMO2P8'){
        for(let i = 0; i < areas[modelo].length; i++){
          let key = Object.keys(areas[modelo][i])[0];
          $('.areas').append(`<span class="area ${i === 0 ? 'active' : ''}" id="${key}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${key}</span>`)
        }
        $('.areas').append('<br />')
        $('.areas').append('<li class="li-options"><span>Zoom: </span></li>')
        for(let i = 0; i < areas[modelo].length; i++){
          let key = Object.keys(areas[modelo][i])[0];
          for(let j = 0; j < areas[modelo][i][key].length; j++){
            $('.areas').append(`<span class="area" id="${key}-${areas[modelo][i][key][j]}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${areas[modelo][i][key][j]}</span>`)
          }
          $('.areas').append('<br />')
        }
      } else {
        for(let i = 0; i < areas[modelo].length; i++){
          $('.areas').append(`<span class="area ${i === 0 ? 'active' : ''}" id="${areas[modelo][i]}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${areas[modelo][i]}</span>`)
        }
      }
    }
    
    function controlActiveValidade(id) {
      $('.validades .validade').removeClass('active');
      $(`#${id}`).addClass('active');
    }

    function controlActiveArea(id) {
      $('.areas .area').removeClass('active');
      $(`#${id}`).addClass('active');
    }

    function initImagem(){
      $('.img').attr('src', Loading);

      var inicializacoes = function () {
        var tmp = null;
        $.ajax({
          'async': false,
          'type': 'GET',
          'url': `${api_baseUrl}/inicializacao/${init_modelo}/${init_area}/${init_parametro}`,
          'success': function (response) {
            tmp = response;
          }
        });
        return tmp;
      }();
      init_data = inicializacoes[0].sigla.split('H')[0]
      init_rodada = inicializacoes[0].sigla.split('H')[1]
      
      validades_imagem = function () {
        var tmp = null;
        $.ajax({
          'async': false,
          'type': 'GET',
          'url': `${api_baseUrl}/validades/${init_modelo}/${init_area}/${init_parametro}/${init_data}/${init_rodada}`,
          'success': function (response) {
            tmp = response;
          }
        });
        return tmp;
      }();
      
      imagens = function () {
        var tmp = null;
        $.ajax({
          'async': false,
          'type': 'GET',
          'url': `${api_baseUrl}/${init_modelo}/${init_area}/${init_parametro}/${inicializacoes[0].sigla}`,
          'success': function (response) {
            tmp = response;
          }
        });
        return tmp;
      }();
      
      imagem_atual = 0; // Seta a imagem da primeira validade para ser mostrada
      $('.img').attr('src', imagens[imagem_atual].base64);
      montarValidades(); // Monta a div das validades da imagem
      $('.previsaoList').css('display', 'inline'); // Mostra a div das validades
    }

    function initMenu(){
      $.get(`${api_baseUrl}/modelos`, function(response) {
        geraOptions($('.modelo'), response, true, init_modelo);
      });
      
      $.get(`${api_baseUrl}/parametros/${init_modelo}/${init_area}`, function(response) {
        geraOptions($('.parametro'), response, true, init_parametro);
      });

      $.get(`${api_baseUrl}/inicializacao/${init_modelo}/${init_area}/${init_parametro}`, function(response) {
        geraOptions($('.inicializacao'), response, true);
      });

      montarAreas(init_modelo)
    }

    $(document).ready(function() {
      initImagem();
      initMenu();
      abrirMenu(true);

      $('.modelo').change(async function() {
          removeOption($('.parametro'));
          removeOption($('.inicializacao'));

          let modelo = $('.modelo').val();
          montarAreas(modelo)

          let area = $('.areas .active')[0].id;

          await $.get(`${api_baseUrl}/parametros/${modelo}/${area}`, function(response) {
            if($('.parametro').is(':empty'))
              geraOptions($('.parametro'), response, true, init_parametro);
          });

          let parametro = $('.parametro').val();

          await $.get(`${api_baseUrl}/inicializacao/${modelo}/${area}/${parametro}`, function(response) {
            if($('.inicializacao').is(':empty'))
              geraOptions($('.inicializacao'), response);
          });

          submit()
      });

      $('.parametro').change(function() {
        submit()
      });

      $('.inicializacao').change(function() {
        submit()
      });
    });

    $('.areas').on('click', '.area', function() {
      controlActiveArea(this.id);
      submit()
    });

    function submit() {
      var modelo        = $('.modelo').val();
      var area          = $('.areas .active')[0].id;
      var parametro     = $('.parametro').val();
      var inicializacao = $('.inicializacao').val();
      var data          = inicializacao.split('H')[0];
      var rodada        = inicializacao.split('H')[1];
      
      if(modelo && parametro && area && inicializacao){
        $('.img').attr('src', Loading);
        
        $.get(`${api_baseUrl}/validades/${modelo}/${area}/${parametro}/${data}/${rodada}`, function(response) {
          validades_imagem = response;
        });
        
        $.get(`${api_baseUrl}/${modelo}/${area}/${parametro}/${inicializacao}`, function(response) {
          imagens = response;
          imagem_atual = 0;
          
          if(imagens[imagem_atual] !== undefined) {
            $('.img').attr('src', imagens[imagem_atual].base64);
            $('.img').attr('alt', 'Vima');
            
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          } else {
            $('.img').attr('src', '');
            $('.img').attr('alt', 'Não há imagem');

            $('.validades').find('span').remove()
            $('.previsaoList').css('display', 'inline');
          }
        });
      }
    }

    $('.primeiro').click(function(e) {
      imagem_atual = 0;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActiveValidade(imagem_atual);
    });
    
    $('.anterior').click(function(e) {
      imagem_atual > 0 ? imagem_atual-- : imagem_atual = imagens.length - 1;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActiveValidade(imagem_atual);
    });

    $(function() {
      var loop = null;
      
      $('.play').click(function() {
        $('.play').css('display', 'none'); // Esconde o botão de play
        $('.parar').css('display', 'inline'); // Mostra o botão de parar
        
        if (loop !== null) return; // Caso o botão de stop seja acionado o loop termina
        
        // Enquanto está com loop ativo, vai percorrendo todo o array de imagens
        loop = setInterval(function() {
          (imagem_atual < (imagens.length - 1)) ? imagem_atual++ : imagem_atual = 0;
          
          $('.img').attr('src', imagens[imagem_atual].base64);
          controlActiveValidade(imagem_atual);
        }, rotate_delay);
      });
      
      // botão de stop acionado
      $('.parar').click(function() {
        $('.parar').css('display', 'none'); // Mostra o botão de play
        $('.play').css('display', 'inline'); // Esconde o botão de parar
        
        clearInterval(loop);
        loop = null
      });
    });

    $('.proximo').click(function(e) {
      imagem_atual < (imagens.length - 1) ? imagem_atual++ : imagem_atual = 0;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActiveValidade(imagem_atual);
    });

    $('.ultimo').click(function(e) {
      imagem_atual = imagens.length - 1;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActiveValidade(imagem_atual);
    });
        
    $('.validades').on('click', '.validade', function() {
      imagem_atual = this.id; // Imagem atual vira a validade selecionada
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActiveValidade(this.id); // Muda a classe 'active' da validade anterior para a nova
    });

    $('.ativar-fullScreen').click(function(e) {
      $('.ativar-fullScreen').css('display', 'none');
      // $('.previsaoList').css('max-height', '7%');
      $('.img').css('max-height', '95%');
      $('.img').css('height', '95%');
      $('.img').css('top', '48%');

      // Esconde o topo do site, deixando só a imagem e os controladores
      var element = $("#containerFullScreen")[0];
      var tmp = element.mozRequestFullScreen || element.webkitRequestFullscreen || element.requestFullscreen;
      tmp.call(element); 
    });
    
    $('#containerFullScreen').bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
      var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      var event = state ? 'FullscreenOn' : 'FullscreenOff';
      
      if(event === 'FullscreenOff'){
        $('.ativar-fullScreen').css('display', 'inline');
        // $('.previsaoList').css('max-height', '12%');
        $('.img').css('max-height', '88%');
        $('.img').css('height', '88%');
        $('.img').css('top', '51%');
      }
    });

    function urlToPromise(url) {
      return new Promise(function(resolve, reject) {
        JSZipUtils.getBinaryContent(url, function (err, data) {
          err ? reject(err) : resolve(data);
        });
      });
    }
    
    $('.baixarZip').click(function(e) {
      var zip = new JsZip();
      
      var produto = 'vime';
      var modelo = $('.modelo').val();
      var area = $('.area').val();
      var parametro = $('.parametro').val();
      var inicializacao = $('.inicializacao').val();
      var data = inicializacao.split('H')[0];
      var rodada = inicializacao.split('H')[1];
      
      var output_name = `${produto}_${modelo}_${area}_${parametro}_${data}_${rodada}.zip`;
      
      for(var i = 0; i < imagens.length - 1; i++){
        var img_extensao = 'png';
        
        zip.file(
          `${imagens[i].nome}.${img_extensao}`, // Filename
          urlToPromise(`${imagens[i].base64}`), // URL
          { binary : true }
          ); 
        }
        
        zip.generateAsync( { type : 'blob' } ).then(function(content) { saveAs(content, output_name); });
    });

    // ========== INICIO MENU LATERAL ==========
    function mobilecheck() {
      var check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  
    function gnMenu( el, options ) {	
      this.el = el;
      this._init();
    }

    gnMenu.prototype = {
      _init : function() {
        this.trigger = this.el.querySelector( 'a.gn-icon-menu' );
        this.menu = this.el.querySelector( 'nav.gn-menu-wrapper' );
        isMenuOpen = false;
        this.eventtype = mobilecheck() ? 'touchstart' : 'click';
        this._initEvents();
  
        var self = this;
        this.bodyClickFn = function() {
          self._closeMenu();
          this.removeEventListener( self.eventtype, self.bodyClickFn );
        };
      },
      _initEvents : function() {
        var self = this;
  
        if( !mobilecheck() ) {
          this.menu.addEventListener( 'mouseover', function(ev) {
            self._openMenu(); 
            document.addEventListener( self.eventtype, self.bodyClickFn ); 
          } );
        }
        this.trigger.addEventListener( this.eventtype, function( ev ) {
          ev.stopPropagation();
          ev.preventDefault();
          if( isMenuOpen ) {
            self._closeMenu();
            document.removeEventListener( self.eventtype, self.bodyClickFn );
          }
          else {
            self._openMenu();
            document.addEventListener( self.eventtype, self.bodyClickFn );
          }
        } );
        this.menu.addEventListener( this.eventtype, function(ev) { ev.stopPropagation(); } );
      },
      _openIconMenu : function() {
        classie.add( this.menu, 'gn-open-part' );
      },
      _closeIconMenu : function() {
        classie.remove( this.menu, 'gn-open-part' );
      },
      _openMenu : function() {
        if( isMenuOpen ) return;
        classie.add( this.trigger, 'gn-selected' );
        isMenuOpen = true;
        classie.add( this.menu, 'gn-open-all' );
        this._closeIconMenu();
      },
      _closeMenu : function() {
        if( !isMenuOpen ) return;
        classie.remove( this.trigger, 'gn-selected' );
        isMenuOpen = false;
        classie.remove( this.menu, 'gn-open-all' );
        this._closeIconMenu();
      }
    }

    new gnMenu( document.getElementById( 'gn-menu' ) );
    // ========== FIM MENU LATERAL ==========
  }
    
  render() {
    return (
      <div className="App">
        <div className="container">
          <ul id="gn-menu" className="gn-menu-main">
            <li className="gn-trigger">
              {/* eslint-disable-next-line */}
              <a className="gn-icon-menu" id="menu">
                <span>Abrir / Fechar</span>
              </a>
              <nav className="gn-menu-wrapper" id="wrapper">
                <div className="gn-scroller">
                  <ul className="gn-menu">
                    {/* <li><span>INMET :: Vime</span></li>
                    <hr /> */}
                    <li className="li-options li-area">
                      <span>Áreas: </span>
                      <div className="areasList">
                        <div className="areas"></div>
                      </div>
                    </li>
                    <li className="li-options"><span>Modelos: </span><select className="modelo"></select></li>
                    <li className="li-options"><span>Mapas: </span><select className="parametro"></select></li>
                    <li className="li-options"><span>Inicialização: </span><select className="inicializacao"></select></li>
                    <hr />
                    <div className="validadesList">
                      <div className="download"><span className="baixarZip">Download de Todas as Imagens</span></div>
                      <span className="horasPrevisao">Horas de Previsão: </span>
                      <div className="validades"></div> 
                    </div>
                  </ul>
                </div>
              </nav>
            </li>
            <li className="inmetName"><a href="https://portal.inmet.gov.br/">Instituto Nacional de Meteorologia</a></li>
          </ul>
          
          <div id="containerFullScreen">
            <div className="imgWrapper"><img className="img" alt=""/></div>

            {/* ========== INICIO CONTROLADORES DA IMAGEM ========== */}
            <div className="previsaoList">
              <span className="primeiro"><FontAwesomeIcon icon={faFastBackward} size="2x" /></span>
              <span className="anterior"><FontAwesomeIcon icon={faBackward} size="2x" /></span>
              <span className="play"><FontAwesomeIcon icon={faPlay} size="2x" /></span>
              <span className="parar"><FontAwesomeIcon icon={faStop} size="2x" /></span>
              <span className="proximo"><FontAwesomeIcon icon={faForward} size="2x" /></span>
              <span className="ultimo"><FontAwesomeIcon icon={faFastForward} size="2x" /></span>
              {/* <br /><br /> */}
              <span className="ativar-fullScreen"><font size="5">Tela Cheia</font></span>
            </div>
            {/* ========== INICIO CONTROLADORES DA IMAGEM ========== */}
          </div>
        </div>
      </div>
      );
    }
  }
export default Index;
    